<app-education-history-list [workerId]="workerId"></app-education-history-list>
